import { Box, IconButton, List, ListItem, ListItemText, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

const getFullName = (user) => [user?.name, user?.last_name].filter(Boolean).join(" ");

const SelectedUsersList = ({ users = [], onRemove, onClear }) => {
  if (!users.length) return null;

  return (
    <Box mt={1.5}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Typography variant="subtitle2">Seleccionados ({users.length})</Typography>

        <Typography role="button" sx={{ fontSize: 13, cursor: "pointer", color: "#003C75" }} onClick={onClear}>
          Quitar todos
        </Typography>
      </Box>

      <List
        dense
        sx={(theme) => ({
          border: `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
          borderRadius: 1.5,
          maxHeight: 200,
          overflow: "auto",
        })}
      >
        {users.map((user) => (
          <ListItem
            key={user.id}
            secondaryAction={
              <IconButton edge="end" onClick={() => onRemove(user.id)} aria-label="quitar">
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
            <ListItemText
              primary={getFullName(user) || "Sin nombre"}
              secondary={user.email || user.id_document}
              primaryTypographyProps={{ fontWeight: 600 }}
              secondaryTypographyProps={{ fontSize: 12 }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default SelectedUsersList;
